import React, { useState, useEffect } from 'react';
import PageWrapper from "../componenti/PageWrapper";
import { Typography, Box, CircularProgress } from "@mui/material";
import Evento from "../componenti/Evento";
import DashboardGrid from "../componenti/DashboardGrid";
import PageContent from "../componenti/PageContent";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { API_BASE_URL, UPLOADS_BASE_URL } from '../context/AuthContext';

function Passati() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPastEvents = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/events.php?is_past=1`);
        const data = await response.json();
        if(Array.isArray(data)) {
          setEvents(data);
        }
      } catch (error) {
        console.error("Errore fetch past events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPastEvents();
  }, []);

  return (
    <PageWrapper>
      <PageContent title="Eventi passati">
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {loading ? (
            <CircularProgress />
          ) : events.length === 0 ? (
            <Typography variant="body1">Nessun evento passato presente.</Typography>
          ) : (
            <DashboardGrid gap={16} minColumnWidth={355}>
              {events.map((item) => (
                <Evento
                  key={item.id}
                  date={item.event_date}
                  time={item.event_time}
                  title={item.title}
                  text={
                    <Typography variant="body2" component="div" sx={{ whiteSpace: 'pre-line' }}>
                      {item.text_content}
                      {item.image_url && (
                        <Box mt={2} display="flex" alignItems="center" gap={0.5}>
                          <AttachFileIcon fontSize="small" color="primary" />
                          <a 
                            href={item.image_url.startsWith('http') || item.image_url.startsWith('../') ? item.image_url : `${UPLOADS_BASE_URL}/${item.image_url.replace(/^\//, '')}`} 
                            target="_blank" 
                            rel="noreferrer"
                            style={{ color: '#1976d2', fontWeight: 600, textDecoration: 'underline' }}
                          >
                            Locandina
                          </a>
                        </Box>
                      )}
                    </Typography>
                  }
                />
              ))}
            </DashboardGrid>
          )}
        </Box>
      </PageContent>
    </PageWrapper>
  );
}

export default Passati;
